import React, { useState } from 'react';
import * as formService from '../../form-services/admin-signin';
import { BwjViewState } from '../../../../framework/components/bwj-view-manager';
import { useToast } from '../../../../framework/components/bwj-toast/context';
import { MessageBarType } from '@fluentui/react';
import { AdminSignInService } from '../../../../services/admin-signin';
import { useNavigator } from '../../../../framework/services/navigation';
import { AppRoutes } from '../../../app-routes';
import { UiAdminSignIn } from './ui';

const subscriberId = 'Page.AdminSignIn';

export const PageAdminSignIn: React.FunctionComponent = () => {
  const formModel = formService.useFormModel(subscriberId);
  const [viewState, setViewState] = useState(BwjViewState.Ready);
  const { showToast } = useToast();
  const nav = useNavigator();

  const onSignIn = () => {
    formService.validateAndUpdateModel()
    .then(result => {
      if(result.isValid === false) { return null; }

      setViewState(BwjViewState.Loading);
      const vm = formService.toValueModel();
      const req = formService.toAdminAuthRequest();
      return AdminSignInService.signIn(vm.username, req);
    })
    .then(result => {
      if(!result) { return; }

      if(result.success) {
        nav.goTo(AppRoutes.home.url());
      } else {
        formService.signInFailed.onUpdate(true);
        setViewState(BwjViewState.Ready);
      }
    })
    .catch(() => {
      setViewState(BwjViewState.Ready);
      showToast(MessageBarType.error, 'An unexpected error occurred');
    });
  }

  return (
    <UiAdminSignIn
      viewState={viewState}
      formModel={formModel}
      onSignIn={onSignIn}
    />
  );
};
/*interface IUiAdminSignInProps {
  viewState: BwjViewState;
  formModel: IAdminSignInFormModel;
  onSignIn: () => void;
} */